import {
	faCheck,
	faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { Step, Stepper, Typography } from '@material-tailwind/react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const steps = [
	{ title: 'Take a selfie' },
	{ title: 'Scan ID' },
	{ title: 'Travel Details' },
];
type VerificationStepperProps = {
	activeStep?: number;
	failedStep?: number | null;
	completedSteps?: number[];
};
const VerificationStepper = ({
	activeStep = 0,
	failedStep = null,
	completedSteps = [],
}: VerificationStepperProps) => {
	let displayedActiveStep = activeStep;

	while (
		displayedActiveStep < steps.length - 1 &&
		completedSteps.includes(displayedActiveStep)
	) {
		displayedActiveStep += 1;
	}

	return (
		<div className="w-full">
			<div className="w-full px-5 pt-4 pb-8">
				<Stepper
					activeStep={displayedActiveStep}
					lineClassName="bg-blue-200"
					activeLineClassName={`${
						failedStep !== null ? 'bg-red-400' : 'bg-green-500'
					}`}>
					{steps.map((step, index) => {
						const isCompleted =
							completedSteps.includes(index) && index !== failedStep;
						const isFailed = index === failedStep;
						const activeStepClassName = isFailed
							? 'border-red-500 bg-red-500 text-white'
							: isCompleted
							? 'border-green-500 bg-green-500 text-white'
							: 'border-black bg-white text-black';
						return (
							<Step
								key={index}
								className={`
                  h-8 w-8 flex items-center justify-center relative border
                  ${
										isFailed
											? 'border-red-500 bg-red-500 text-white'
											: isCompleted
											? 'border-green-500 bg-green-500 text-white'
											: 'border-black bg-white text-black'
									}
                `}
								activeClassName={activeStepClassName}
								completedClassName="border-green-500 bg-green-500 text-white">
								{/* Icon / Number */}
								{isFailed ? (
									<FontAwesomeIcon
										icon={faCircleExclamation}
										className="text-sm text-white"
									/>
								) : isCompleted ? (
									<FontAwesomeIcon
										icon={faCheck}
										className="text-sm text-white"
									/>
								) : (
									<span className="text-sm font-semibold">{index + 1}</span>
								)}

								{/* Label */}
								<div className="absolute -bottom-9 left-1/2 -translate-x-1/2 w-max">
									<Typography
										variant="small"
										className={`text-center ${
											isFailed ? 'text-red-500 font-semibold' : 'text-black'
										}`}>
										{step.title}
									</Typography>
								</div>
							</Step>
						);
					})}
				</Stepper>
			</div>
		</div>
	);
};

export default VerificationStepper;
